// The built-in point-of-interest glyphs: 24×24 stroke drawings, one
// per system POI type. The icon picker (iconLibrary.js) registers them
// from here, and the public trail page draws its map markers from here
// without importing that 46 kB registry into the site bundle — one
// definition, so the marker on a club's website is the icon the
// manager picked in the dashboard.
export const POI_BUILTIN_PATHS = {
    trailhead: '<path d="M3 19l5-7 4 5 3-4 6 6z"/><path d="M9 9l1-2 1 2"/>',
    parking:   '<rect x="4" y="4" width="16" height="16" rx="3"/><path d="M10 17V8h3a3 3 0 010 6h-3"/>',
    viewpoint: '<path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
    water:     '<path d="M12 3c4 5 7 8 7 12a7 7 0 11-14 0c0-4 3-7 7-12z"/>',
    campsite:  '<path d="M3 20l9-15 9 15z"/><path d="M9 20l3-5 3 5"/>',
    restroom:  '<circle cx="12" cy="6" r="2"/><path d="M9 11h6l-1 4-1 5h-2l-1-5z"/>',
    shelter:   '<path d="M3 12L12 4l9 8"/><path d="M5 12v8h14v-8"/>',
    gate:      '<rect x="3" y="6" width="18" height="12" rx="1"/><path d="M3 12h18"/>',
    hazard:    '<path d="M12 4l9 16H3z"/><path d="M12 10v4M12 17h.01"/>',
    trail_map: '<path d="M9 3L3 5v16l6-2 6 2 6-2V3l-6 2-6-2z"/><path d="M9 3v16M15 5v16"/>',
    other:     '<path d="M12 22s-8-8.3-8-13a8 8 0 0116 0c0 4.7-8 13-8 13z"/><circle cx="12" cy="9" r="2.5"/>',
};

/** The glyph for a POI: its type's icon when that is a built-in one,
 *  then its category's, then the plain pin. A custom type whose icon
 *  lives in the extended catalog draws the pin here rather than
 *  pulling that catalog onto a public page. */
export function poiGlyph(icon, category) {
    return POI_BUILTIN_PATHS[icon] || POI_BUILTIN_PATHS[category] || POI_BUILTIN_PATHS.other;
}
